import type { AccessDecision } from '../../../core/components/PermissionGuard/PermissionGuard';

type ResolveSupportCenterAccessParams = {
  flagEnabled: boolean;
  isChecking: boolean;
  countryAllowed: boolean;
};

export const resolveSupportCenterAccess = ({
  flagEnabled,
  isChecking,
  countryAllowed,
}: ResolveSupportCenterAccessParams): AccessDecision => {
  if (!flagEnabled) return 'deny';
  if (isChecking) return 'loading';
  return countryAllowed ? 'allow' : 'deny';
};
